<script lang="ts">
	import Icon from "@components/common/Icon.svelte";
	import type { ClassValue } from "svelte/elements";
	import arrowIconDefault from "@core/assets/icons/arrow.svg?raw";

	const {
		class: className,
		arrowIcon = arrowIconDefault,
	}: {
		class?: ClassValue;
		arrowIcon?: string;
	} = $props();
</script>

<span class={["inline-flex items-center", className]} aria-hidden="true">
	<span class="arrow-wiggle">
		<Icon icon={arrowIcon} class="size-full" />
	</span>
</span>

<style>
	@keyframes arrow-wiggle {
		0% {
			transform: translateX(0);
		}
		65% {
			transform: translateX(6px);
		}
		100% {
			transform: translateX(0);
		}
	}

	:global(.group:hover) .arrow-wiggle {
		animation: none;
	}

	@media (hover: hover) and (pointer: fine) {
		:global(.group:hover) .arrow-wiggle {
			animation: arrow-wiggle 1100ms ease-in-out infinite;
		}
	}
</style>
